<template>
    <div class="headerIncomeWidget_wrap">
        <div class="headerIncomeWidget_wrap-data">
            <div class="headerIncomeWidget_title">
                <div class="headerIncomeWidget_text">
                    {{incomeTitle}}
                </div>
                <!--<des v-show="getStatusHeader" :text = "incomeType[type].textDesc"></des>-->
            </div>
            <div class="headerIncomeWidget_bigData">
                <div class="headerIncomeWidget_balance"
                    :class = "(incomeType[type].dataMain < 0) ? 'color-red' : 'color-green'">

                        <watch :data="incomeType[type].dataMain"
							   :units="'$'"
						>

						</watch>
                </div>
                <div class="headerIncomeWidget_data">
                    <div class="headerIncomeWidget_dataItem"
                        :class = "(incomeType[type].dataSub < 0) ? 'color-red' : 'color-green'">
                            {{incomeType[type].dataSub}}%
                    </div>
                </div>
                <div v-if = "incomeType[type].dataPoints != 0" class="headerIncomeWidget_dataItem"
                            :class = "(incomeType[type].dataPoints < 0) ? 'color-red' : 'color-green'">
                            {{$moneyf(incomeType[type].dataPoints,0)}} pip
                </div>
            </div>
            <!--<div class="headerIncomeWidget_maxdd"
                :class = "((incomeType[type].dataDD === 0) ? 'color-yellow' : 'color-red')">
                MAX. DD {{incomeType[type].dataDD}}%
            </div>-->
        </div>
        <div class="headerIncomeWidget_wrap-chart">
            <chart v-if="chart"
                :data="incomeType[type].dataMain"
                :points="points"
                :plotShadow="true"
                :margin="{ top: 8, right: 8, bottom: 8, left: 0 }"
                :fixedWidth="180"
                :fixedHeight="120"
                :smooth="true"
                ></chart>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Chart from '../../../ui-components/ui-mini-linechart.vue'
import Watcher from '../../../ui-components/ui-data-watcher.vue'
export default {
    components: {
        'chart':Chart,
        'watch':Watcher
    },
    props: {
        incomeTitle: { default: "" },
        type: { default: "equity" },
        chart: {default: true},
        param: {default: 'bal'}
    },
    data() {
        return {
        symbol:'',
        statistic: {},
        incomeType: {
            plCur: {
                    dataMain: 0,
                    dataSub: 0,
                    dataPoints: 0,
                    dataDD:0
                },
            plAbs: {
                    dataMain: 0,
                    dataSub: 0,
                    dataPoints: 0,
                    dataDD:0
                },
                plGross: {
                    dataMain: 0,
                    dataSub: 0,
                    dataPoints: 0,
                    dataDD:0
                },
                equity: {
                    dataMain: 0,
                    dataSub: 0,
                    dataPoints:'',
                    dataDD:0
                },
                changeDay: {
                    dataMain: 0,
                    dataPoints: '',
                    dataDD: 0
                },
            balance: {
                dataMain: 0,
                dataSub: 0,
                dataPoints:'',
                dataDD:0
            }
        },
        plCur: 0,
        filterOpenPositions: [
            { field: "symbol", dir: "asc" },
            { field: "timeEnter", dir: "asc" }
        ],
        points:[]
        }
    },
    computed: {
        ...mapGetters({
            getStatistics: "accountstat/getStatistics",
            //getStatusHeader:'usersets/getHeader'
        }),
        statOpenPositions() {
            let flatStat = this.$store.getters["positions/positionsFlatFiltered"](this.filterOpenPositions);
            let sumPoints = 0;
            for (let i = 0; i < flatStat.length; i++)
                sumPoints += flatStat[i].resultPoint;
            return sumPoints;
        },
        deltaEquity() {
            return ((this.statistic.Summary.Equity - this.statistic.DailyRecords[this.statistic.DailyRecords.length - 1].EquityOpen) / this.statistic.Summary.Equity * 100
        );
        }
    },
    methods: {
        pointForChart (stat, param) {
            let point = [];
            let lastData = stat.DailyRecords.slice(-10);
            if(param === 'bal') {
                for(let i = 0; i < stat.DailyRecords.length; i++)
                    point.push(stat.DailyRecords[i].BalanceClose)
                this.points = point.slice(-10);
            } else if(param === 'eq'){
                    for(let i = 0; i < stat.DailyRecords.length; i++)
                    point.push(stat.DailyRecords[i].EquityClose)
                this.points = point.slice(-10);
            } else if(param === 'plAbs') {
                this.points = []
                for(let i = 0; i < lastData.length; i++)
                    this.points.push((lastData[i].EquityClose - 1000000) * 100 / lastData[i].EquityClose);
            } else if(param === 'plCur') {
                this.points = []
                for(let i = 0; i < lastData.length; i++)
                    this.points.push(lastData[i].EquityClose - lastData[i].BalanceClose)
            } else if(param === 'changeDay') {
                this.points = []
                for(let i = 0; i < lastData.length; i++)
                    this.points.push(lastData[i].EquityClose - lastData[i].EquityOpen)
            }
        },
        updateStatistics(symbol) {
            if (!symbol) symbol = this.symbol;
                let stat = this.getStatistics(symbol);
            if (!stat) {
                return;
            }
            this.statistic = stat;
            this.pointForChart(stat, this.param);
            this.incomeType = {
                plCur: {
                    dataMain: (this.plCur = stat.DailyRecords[stat.DailyRecords.length - 1].EquityClose - stat.DailyRecords[stat.DailyRecords.length - 1].BalanceClose),
                    dataSub: (this.plCur * 100 / stat.DailyRecords[stat.DailyRecords.length - 1].EquityClose).toFixed(2),
                    dataPoints: 0,
                    dataDD:0,
                    textDesc: 'Фактическая величина изменения капитала с учетом открытых позиций (по открытым позициям).'
                },
                plAbs: {
                    dataMain: stat.Summary.ProfitAbs,
                    dataSub: (100/(1000000/stat.Summary.ProfitAbs)).toFixed(2),
                    dataPoints: stat.Summary.ProfitPoints,
                    dataDD:0,
                    textDesc: 'Разница между общей прибылью и общим убытком за расчетный период'
                },
                plGross: {
                    dataMain: stat.Summary.GrossProfit - stat.Summary.GrossLoss,
                    dataSub: (100/(1000000/(stat.Summary.GrossProfit - stat.Summary.GrossLoss))).toFixed(2),
                    dataPoints: '',
                    dataDD:0,
                    textDesc: 'Разница между общей прибылью и общим убытком за расчетный период'
                },
                equity: {
                    dataMain: stat.DailyRecords[stat.DailyRecords.length - 1].EquityClose,
                    dataSub: ((stat.Summary.Equity - stat.DailyRecords[stat.DailyRecords.length  - 1].EquityOpen) / stat.Summary.Equity * 100).toFixed(2),
                    dataPoints:'',
                    dataDD:0,
                    textDesc: 'Денежные ресурсы счета с учетом текущих позиций (баланс + floating profit/loss)'
                },
                changeDay: {
                    dataMain: stat.DailyRecords[stat.DailyRecords.length - 1].EquityClose - stat.DailyRecords[stat.DailyRecords.length - 1].EquityOpen,
                    dataSub: ((stat.DailyRecords[stat.DailyRecords.length - 1].EquityClose - stat.DailyRecords[stat.DailyRecords.length - 1].EquityOpen) / stat.DailyRecords[stat.DailyRecords.length - 1].EquityOpen * 100).toFixed(2),
                    dataPoints: '',
                    dataDD: stat.DailyRecords[stat.DailyRecords.length - 1].DrawdownHigh,
                    textDesc: 'Изменения денежных русурсов на текущий момент времени'
                },
                balance: {
                    dataMain: stat.DailyRecords[stat.DailyRecords.length - 1].BalanceClose,
                    dataSub: ((stat.Summary.Balance - stat.DailyRecords[stat.DailyRecords.length  - 1].BalanceClose) / stat.Summary.Balance * 100).toFixed(2),
                    dataPoints: '',
                    textDesc: 'Совокупный финансовый результат всех закрытых сделок и не торговых операций по счету (прибыли\убытки, комиссии, пополнения\снятия).'
                }
            };
        }
    },
    watch: {
        symbol: function(val) {
            this.$store.dispatch("accountstat/unsubscribeFromUpdate", this.symbol);
            if (!this.symbol || !this.symbol.length)
                return;
            subscribeOnUpdate(this.$store, val, isFirstObtained => {
                this.updateStatistics();
            });
            this.updateStatistics();
        }
    },
    created() {
        subscribeOnUpdate(this.$store, "", isFirstObtained => {
            this.updateStatistics();
        });
        this.updateStatistics();
    }
    };

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "header-income-mobile",
            handler: handler
        }
    });
}
</script>
<style lang="less" scoped>
.icon-arrow-up {
        font-size: 43px !important;
        width: 41px !important;
        padding-right: 20px !important;
}
.headerIncomeWidget {
    &_bigData {
        //display: flex;
        //justify-content: space-between;
    }
  &_wrap {
    display: flex;
    background: #3d536b;
    overflow: hidden;
    //border-radius: 8px;
    margin-bottom: 4px;
    height: 120px;
    justify-content: space-between;
    &-data {
        flex-grow: 1;
        flex-basis: 100%;
        //min-width: 43%;
        padding: 8px 0px 8px 16px;
    }
    &-chart {
        flex-grow: 1;
        max-width: 180px;
    }
  }

  &_title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    min-height: 18px;
  }

  &_text {
    font-family: Montserrat;
    font-size: 11px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.18;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color:#fff;
  }

  &_balance {
    font-family: Arimo;
    font-size: 20px;
    //font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: @colors[green];
    margin-bottom: 0px;
    display: flex;
    align-items: center;
  }

  &_data {
    display: flex;
  }

  &_dataItem {
    font-family: Arimo;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.54;
    letter-spacing: normal;
    color: #0fd7b7;
    margin-right: 4px;
  }

  &_maxdd {
    font-family: Arimo;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: 0.4px;
    color: #ff9292;
    margin-top: 4px;
  }
}
</style>
